// extracted by mini-css-extract-plugin
export default {"hidden":"Hidden_hidden__Jo+KU"};